import React from 'react'

import Promo from '../../../components/Promo'
import buildImageUrl from '../../../../lib/media-url-maker'

const widget = {
  id: 'homepage-floaty-promo'
}

const FloatyPromo = (props) => {
  const imageUrl = buildImageUrl({
    width: 800,
    mode: 'cover',
    resource:
      props.images.widgets[0].crops &&
      props.images.widgets[0].crops[0] &&
      props.images.widgets[0].crops[0].src
  })

  return <Promo {...props} posterSrc={imageUrl} sessionDismissId={widget.id} />
}

export default FloatyPromo
